import * as React from "react";
import styled from "styled-components";

import { ReleaseIndexSchema } from "../../../../../services/search-admin/types/index-schema/release-index-schema";
import { GridSelectionModelChangeParams } from "@material-ui/data-grid";
import { searchReleases } from "../../sdk/search";

import genreList from './genres.json';
import languageList from './languages.json';

import {
  Checkbox,
  FormControlLabel,
  Input,
  ListItemText,
  MenuItem,
  OutlinedInput,
  Select,
  Switch,
  Toolbar,
  Typography,
} from "@material-ui/core";
import { ReleaseStatus } from "../../../../../common/types/release/relase-status";
// import { ReleaseDetailActions } from "../../controllers/releases/detail/detail-actions";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import Button from "@material-ui/core/Button";
import { ReleaseGrid } from "../../controllers/releases/release-grid";
import { useHistory, useLocation } from "react-router";
import { TrackType } from '../../../../../common/types/release/track-type';
import { getStores } from "../../sdk/categories";

const getStoredValue = (key: string, defaultValue: any) => {
  if (key in localStorage) {
    return JSON.parse(localStorage.getItem(key) as string);
  }
  return defaultValue;
};

export const ReleasesListPage: React.FC = () => {
  const initialPage = getStoredValue("BACKOFFICE.RELEASE.PAGE", 0);

  const history = useHistory();
  const location = useLocation();
  const [allYears] = React.useState<number[]>(
    (() => {
      const years = [];
      const currentYear = new Date().getFullYear();
      let startYear = 2020;
      while (startYear <= currentYear + 1) {
        years.push(startYear);
        startYear++;
      }
      return years;
    })()
  );

  const [loading, setLoading] = React.useState(false);
  const [size, setSize] = React.useState(0);
  const [releases, setReleases] = React.useState<ReleaseIndexSchema[]>([]);
  const [page, setPage] = React.useState<number>(initialPage);
  const [stores, setStores] = React.useState<string[]>([]);
  const [selectedStores, setSelectedStores] = React.useState<string[]>(
    getStoredValue('BACKOFFICE.RELEASE.STORES', stores)
  );
  const [startDate, handleStartDateChange] = React.useState<Date | null>(
    getStoredValue("BACKOFFICE.RELEASE.START-DATE", null)
  );
  const [endDate, handleEndDateChange] = React.useState<Date | null>(
    getStoredValue("BACKOFFICE.RELEASE.END-DATE", null)
  );
  const [searchText, setSearchText] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.QUERY", "")
  );
  const [sortModel, setSortModel] = React.useState<any>([
    {
      field:
        "SORT.ITEM" in localStorage
          ? localStorage.getItem("SORT.ITEM")
          : "title",
      sort:
        "SORT.TYPE" in localStorage ? localStorage.getItem("SORT.TYPE") : "asc",
    },
  ]);
  const [status, setStatus] = React.useState<ReleaseStatus>(
    getStoredValue("BACKOFFICE.RELEASE.STATUS", "pending")
  );
  const [backOfficeStatus, setBackOfficeStatus] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.BACK-OFFICE-STATUS", "")
  );
  const [paidItems, setPaidItems] = React.useState(
    getStoredValue("BACKOFFICE.RELEASE.PAID_ITEMS", false)
  );
  const [artistPlan, setArtistPlan] = React.useState(
    getStoredValue("BACKOFFICE.RELEASE.PLAN", "ALL")
  );

  const [selection, setSelection] = React.useState<string[]>([]);
  // const [doneIds, setDoneIds] = React.useState<string[]>([]);
  const [doneIds] = React.useState<string[]>([]);

  const [firstLoad, setFirstLoad] = React.useState(true);

  const [releaseDay, setReleaseDay] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.RELEASEDAY", "ALL")
  );

  const [releaseMonth, setReleaseMonth] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.RELEASEMONTH", new Date().getMonth())
  );

  const [releaseYear, setReleaseYear] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.RELEASEYEAR", new Date().getFullYear())
  );

  const [genre, setGenre] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.GENRE", "ALL")
  );
  const [popularity, setPopularity] = React.useState<number>(
    getStoredValue("BACKOFFICE.RELEASE.POPULARITY", 0)
  );
  const [type, setType] = React.useState<TrackType | 'ALL'>(
    getStoredValue("BACKOFFICE.RELEASE.TYPE", 'ALL')
  );
  const [isExplicit, setIsExplicit] = React.useState<'ALL' | 'EXPLICIT' | 'NON_EXPLICIT'>(
    getStoredValue("BACKOFFICE.RELEASE.EXPLICIT", 'ALL')
  );
  const [trackVersion, setTrackVersion] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.TRACK_VERSION", 'ALL')
  );
  const [language, setLanguage] = React.useState<string>(
    getStoredValue("BACKOFFICE.RELEASE.LANGUAGE", 'ALL')
  );

  const handleResetFilter = () => {
    //
    localStorage.removeItem("BACKOFFICE.RELEASE.QUERY");
    localStorage.removeItem("BACKOFFICE.RELEASE.STATUS");
    localStorage.removeItem("BACKOFFICE.RELEASE.BACK-OFFICE-STATUS");
    localStorage.removeItem("BACKOFFICE.RELEASE.START-DATE");
    localStorage.removeItem("BACKOFFICE.RELEASE.END-DATE");
    localStorage.removeItem("BACKOFFICE.RELEASE.RELEASEDAY");
    localStorage.removeItem("BACKOFFICE.RELEASE.RELEASEMONTH");
    localStorage.removeItem("BACKOFFICE.RELEASE.RELEASEYEAR");
    localStorage.removeItem("BACKOFFICE.RELEASE.PLAN");
    localStorage.removeItem("BACKOFFICE.RELEASE.PAID_ITEMS");
    localStorage.removeItem("BACKOFFICE.RELEASE.GENRE");
    localStorage.removeItem("BACKOFFICE.RELEASE.POPULARITY");
    localStorage.removeItem("BACKOFFICE.RELEASE.TYPE");
    localStorage.removeItem("BACKOFFICE.RELEASE.EXPLICIT");
    localStorage.removeItem("BACKOFFICE.RELEASE.TRACK_VERSION");
    localStorage.removeItem("BACKOFFICE.RELEASE.LANGUAGE");
    localStorage.removeItem("BACKOFFICE.RELEASE.STORES");
    //
    setPaidItems(false);
    setSearchText("");
    setStatus(getStoredValue("BACKOFFICE.RELEASE.STATUS", "pending"));
    setBackOfficeStatus(
      getStoredValue("BACKOFFICE.RELEASE.BACK-OFFICE-STATUS", "")
    );
    handleStartDateChange(
      getStoredValue("BACKOFFICE.RELEASE.START-DATE", null)
    );
    handleEndDateChange(getStoredValue("BACKOFFICE.RELEASE.END-DATE", null));
    setReleaseDay(getStoredValue("BACKOFFICE.RELEASE.RELEASEDAY", "ALL"));
    setReleaseMonth(
      getStoredValue("BACKOFFICE.RELEASE.RELEASEMONTH", new Date().getMonth())
    );
    setReleaseYear(
      getStoredValue("BACKOFFICE.RELEASE.RELEASEYEAR", new Date().getFullYear())
    );
    setArtistPlan(getStoredValue("BACKOFFICE.RELEASE.PLAN", "ALL"));

    setSelectedStores(getStoredValue('BACKOFFICE.RELEASE.STORES', stores));

    setGenre('ALL');
    setPopularity(0);
    setType('ALL');
    setIsExplicit('ALL');
    setTrackVersion('ALL');
    setLanguage('ALL');

    handleSearch(true);
  };

  const handleFilter = <T,>(
    setter: (v: T) => void,
    value: T,
    localKey: string
  ) => {
    localStorage.setItem(localKey, JSON.stringify(value));
    setPage(0);
    setter(value);
  };

  const handleStoresChange = (event: any) => {
    const {
      target: { value },
    } = event;
    if (Array.isArray(value) && value.length === 0){
      return;
    }
    setSelectedStores(
      typeof value === 'string' ? value.split(',') : value,
    );
  }

  const handleSearch = React.useCallback(
    (resetPage = false) => {
      localStorage.setItem(
        "BACKOFFICE.RELEASE.QUERY",
        JSON.stringify(searchText)
      );
      localStorage.setItem(
        "BACKOFFICE.RELEASE.PAGE",
        JSON.stringify(resetPage ? 0 : page)
      );
      setLoading(true);
      setSelection([]);
      if (resetPage) {
        setPage(0);
      }

      const filters = {
        status,
        backOfficeStatus,
        startDate,
        endDate,
        paidItems,
        artistPlan,
        doneIds,
        releaseDay,
        releaseMonth,
        releaseYear,
        stores: selectedStores,

        genre,
        popularity,
        type,
        isExplicit,
        trackVersion,
        language,
      };

      searchReleases(resetPage ? 0 : page, sortModel, searchText, filters)
        .then((data) => {
          setSize(data.total || 0);
          setTimeout(() => setReleases(data.results), 100);
        })
        .finally(() => setLoading(false));
    },
    [
      artistPlan,
      backOfficeStatus,
      doneIds,
      endDate,
      page,
      paidItems,
      releaseDay,
      releaseMonth,
      releaseYear,
      selectedStores,
      genre,
      popularity,
      type,
      isExplicit,
      trackVersion,
      language,
      searchText,
      sortModel,
      startDate,
      status,
    ]
  );

  React.useEffect(() => {
    if (firstLoad) {
      handleSearch(true);
    }
  }, [
    status,
    backOfficeStatus,
    startDate,
    endDate,
    paidItems,
    artistPlan,
    releaseDay,
    releaseMonth,
    releaseYear,
    selectedStores,
    genre,
    popularity,
    type,
    isExplicit,
    trackVersion,
    language,
    searchText,
    firstLoad,
    handleSearch,
  ]);

  React.useEffect(() => {
    handleSearch(false);
  }, [page, doneIds, sortModel, handleSearch]);

  React.useEffect(() => {
    getStores().then((response) => {
      setStores(response.map((s) => s.name));
    })
  }, []);

  React.useEffect(() => {
    setFirstLoad(false);
  }, []);

  const handleSelection = (params: GridSelectionModelChangeParams) => {
    const ids = params.selectionModel.map((s) => s.toString());

    return setSelection(ids);
  };

  // const handleDone = (ids: string[]) => {
  //   setDoneIds(doneIds.concat(ids));
  //   setSelection(selection.filter((s) => !ids.includes(s)));
  // };

  return (
    <section>
      <Toolbar
        variant="dense"
        style={{ marginTop: "20px", display: "flex", flexWrap: "wrap" }}
      >
        <Typography variant="h4" style={{ flexGrow: 1 }}>
          Releases
        </Typography>
        <Button color="inherit" onClick={handleResetFilter}>
          Reset Filters
        </Button>
        <Input
          placeholder="Lookup release"
          inputProps={{ "aria-label": "search" }}
          style={{ width: "300px", marginRight: "1rem" }}
          value={searchText}
          onChange={(ev) => setSearchText(ev.target.value)}
          onKeyDown={(ev) =>
            ev.key === "Enter" ? handleSearch(true) : undefined
          }
        />
        <Select
          onChange={(ev) =>
            handleFilter(
              setStatus,
              ev.target.value as ReleaseStatus,
              "BACKOFFICE.RELEASE.STATUS"
            )
          }
          value={status}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="draft">Draft</MenuItem>
          <MenuItem value="pending">Pending</MenuItem>
          <MenuItem value="changes">Changes Needed</MenuItem>
          <MenuItem value="processing">Processing</MenuItem>
          <MenuItem value="published">Published</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
          <MenuItem value="taken">Taken Down</MenuItem>
          <MenuItem value="blocked">Blocked</MenuItem>
        </Select>
        <Select
          onChange={(ev) =>
            handleFilter(
              setBackOfficeStatus,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.BACK-OFFICE-STATUS"
            )
          }
          value={backOfficeStatus}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="">All Actions</MenuItem>
          <MenuItem value="unreviewed">Unreviewed</MenuItem>
          <MenuItem value="accepted">Approved</MenuItem>
          <MenuItem value="takedown">Takedown</MenuItem>
          <MenuItem value="rejected">Rejected</MenuItem>
          <MenuItem value="request">Requested Changes</MenuItem>
        </Select>
        <DateWrapper>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              disableToolbar
              variant="inline"
              label="Start Date"
              value={startDate}
              onChange={(newDate) =>
                handleFilter(
                  handleStartDateChange,
                  newDate,
                  "BACKOFFICE.RELEASE.START-DATE"
                )
              }
            />
          </MuiPickersUtilsProvider>
        </DateWrapper>
        <DateWrapper>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <DatePicker
              disableToolbar
              variant="inline"
              label="End Date"
              value={endDate}
              onChange={(newDate) =>
                handleFilter(
                  handleEndDateChange,
                  newDate,
                  "BACKOFFICE.RELEASE.END-DATE"
                )
              }
            />
          </MuiPickersUtilsProvider>
        </DateWrapper>
        <Select
          onChange={(ev) =>
            handleFilter(
              setReleaseDay,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.RELEASEDAY"
            )
          }
          value={releaseDay}
          style={{ marginRight: "1rem", width: "120px" }}
        >
          <MenuItem value="ALL">Any Day</MenuItem>
          <MenuItem value="0">Sunday</MenuItem>
          <MenuItem value="1">Monday</MenuItem>
          <MenuItem value="2">Tuesday</MenuItem>
          <MenuItem value="3">Wednesday</MenuItem>
          <MenuItem value="4">Thursday</MenuItem>
          <MenuItem value="5">Friday</MenuItem>
          <MenuItem value="6">Saturday</MenuItem>
        </Select>

        <Select
          onChange={(ev) =>
            handleFilter(
              setReleaseMonth,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.RELEASEMONTH"
            )
          }
          value={releaseMonth}
          style={{ marginRight: "1rem", width: "120px" }}
        >
          <MenuItem value="ALL">Any Month</MenuItem>
          <MenuItem value="0">January</MenuItem>
          <MenuItem value="1">February</MenuItem>
          <MenuItem value="2">March</MenuItem>
          <MenuItem value="3">April</MenuItem>
          <MenuItem value="4">May</MenuItem>
          <MenuItem value="5">June</MenuItem>
          <MenuItem value="6">July</MenuItem>
          <MenuItem value="7">August</MenuItem>
          <MenuItem value="8">September </MenuItem>
          <MenuItem value="9">October</MenuItem>
          <MenuItem value="10">November</MenuItem>
          <MenuItem value="11">December</MenuItem>
        </Select>

        <Select
          onChange={(ev) =>
            handleFilter(
              setReleaseYear,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.RELEASEYEAR"
            )
          }
          value={releaseYear}
          style={{ marginRight: "1rem", width: "120px" }}
        >
          <MenuItem value="ALL">Any Year</MenuItem>
          {allYears.map((x) => {
            return (
              <MenuItem key={x} value={x}>
                {x}
              </MenuItem>
            );
          })}
        </Select>

        <Select
          onChange={(ev) =>
            handleFilter(
              setArtistPlan,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.PLAN"
            )
          }
          value={artistPlan}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="ALL">All Plans</MenuItem>
          <MenuItem value="Beginner">Beginner</MenuItem>
          <MenuItem value="Growth">Growth</MenuItem>
          <MenuItem value="Pro">Pro</MenuItem>
        </Select>
        <Select
          style={{width: "150px", margin: "10px", height: '30px'}}
          labelId="genre-label"
          multiple
          value={selectedStores}
          onChange={handleStoresChange}
          input={<OutlinedInput label="Tag" />}
          renderValue={(selected) => (selected as unknown as string[]).join(', ')}
        >
          {stores.map((item) => (
            <MenuItem key={item} value={item}>
              <Checkbox checked={selectedStores.indexOf(item) > -1} />
              <ListItemText primary={item} />
            </MenuItem>
          ))}
        </Select>
        <FormControlLabel
          control={
            <Switch
              value={paidItems}
              onChange={(ev) =>
                handleFilter(
                  setPaidItems,
                  ev.target.checked,
                  "BACKOFFICE.RELEASE.PAID_ITEMS"
                )
              }
            />
          }
          label="Paid Items"
        />
      </Toolbar>
      <Toolbar
        variant="dense"
        style={{ marginTop: "20px", display: "flex", flexWrap: "wrap" }}
      >
        <Typography variant="h6" style={{ flexGrow: 1 }}>
          Tracks
        </Typography>
        <Select
          onChange={(ev) =>
            handleFilter(
              setGenre,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.GENRE"
            )
          }
          value={genre}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="ALL">All Genres</MenuItem>
          {genreList.map((x) => (
            <MenuItem value={x}>{x}</MenuItem>
          ))}
        </Select>
        <Input
          placeholder="Popularity"
          inputProps={{ "aria-label": "search", min: 0, max: 100, step: 10, title: "Popularity Score" }}
          style={{ width: "100px", marginRight: "1rem" }}
          value={popularity || undefined}
          type="number"
          inputMode="numeric"
          onChange={(ev) => setPopularity(Number(ev.target.value))}
          onKeyDown={(ev) =>
            ev.key === "Enter" ? handleSearch(true) : undefined
          }
        />
        <Select
          onChange={(ev) =>
            handleFilter(
              setType,
              ev.target.value as TrackType,
              "BACKOFFICE.RELEASE.TYPE"
            )
          }
          value={type}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="ALL">All Types</MenuItem>
          <MenuItem value="song">Song</MenuItem>
          <MenuItem value="instrumental">Instrumental</MenuItem>
        </Select>
        <Select
          onChange={(ev) =>
            handleFilter(
              setIsExplicit,
              ev.target.value as 'ALL' | 'EXPLICIT' | 'NON_EXPLICIT',
              "BACKOFFICE.RELEASE.IS_EXPLICIT"
            )
          }
          value={isExplicit}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="ALL">Explicit+Non Explicit</MenuItem>
          <MenuItem value="EXPLICIT">Explicit</MenuItem>
          <MenuItem value="NON_EXPLICIT">Non Explicit</MenuItem>
        </Select>
        <Select
          onChange={(ev) =>
            handleFilter(
              setTrackVersion,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.TRACK_VERSION"
            )
          }
          value={trackVersion}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="ALL">All versions</MenuItem>
          <MenuItem value="Remix">Remix</MenuItem>
          <MenuItem value="Acoustic">Acoustic</MenuItem>
        </Select>
        <Select
          onChange={(ev) =>
            handleFilter(
              setLanguage,
              ev.target.value as string,
              "BACKOFFICE.RELEASE.LANGUAGE"
            )
          }
          value={language}
          style={{ marginRight: "1rem" }}
        >
          <MenuItem value="ALL">All languages</MenuItem>
          {languageList.map((x) => (
            <MenuItem value={x.id}>{x.name}</MenuItem>
          ))}
        </Select>
      </Toolbar>
      <div style={{ display: "flex", height: "700px", marginTop: "20px" }}>
        <ReleaseGrid
          releases={releases}
          loading={loading}
          // hasCheckbox
          size={size}
          page={page}
          selection={selection}
          sortModel={sortModel}
          handlePageChange={setPage}
          handleSortModelChange={(model) => {
            if (
              sortModel[0]?.field !== model?.sortModel[0]?.field ||
              sortModel[0]?.sort !== model?.sortModel[0]?.sort
            ) {
              localStorage.setItem(
                "SORT.ITEM",
                model?.sortModel[0]?.field ?? "title"
              );
              localStorage.setItem(
                "SORT.TYPE",
                model?.sortModel[0]?.sort ?? "asc"
              );
              setSortModel(model.sortModel);
            }
          }}
          handleSelection={handleSelection}
          handleClick={(release, ev) => {
            if (!selection?.length) {
              const url = `${location.pathname}/${release.id}`;
              if (ev.ctrlKey || ev.metaKey) {
                window.open(url, "_blank");
              } else {
                history.push(url, { from: "release-list" });
              }
            }
          }}
        />
      </div>
      {/* {selection.length ? (
        <ActionsContainer>
          <ReleaseDetailActions
            status={status}
            data={releases
              .filter((release) => selection.includes(release.id))
              .map((release) => ({ release }))}
            onAction={handleDone}
          />
        </ActionsContainer>
      ) : null} */}
    </section>
  );
};

// const ActionsContainer = styled.section`
//   margin-top: 1em;
//   overflow: hidden;
//   & > div {
//     max-width: none;
//   }
// `;

const DateWrapper = styled.div`
  max-width: 8rem !important;
  margin-left: 1rem;
  margin-right: 1rem;
`;
